import React, { useState, useEffect } from 'react';
import { Link,useNavigate} from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import {API_BASE_URL} from "../../apiConfig.jsx";
import axios from 'axios';
import {cleanStr,cleanPass} from '../../comfunc.js';
import {strEncode,strDecode} from '../../encrpt.js';
import DataTable from 'react-data-table-component';
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import Select2 from "../../Select2/select2.js";
import DatePicker from "react-datepicker";
import moment from 'moment';

function Redressal() {
    const navigate = useNavigate();
	const [userData, setUserData] = useState(null);
	
	
		useEffect(() => {
			const authToken = localStorage.getItem("authToken");
			//console.log("authToken",authToken)
			if (!authToken) {
				localStorage.removeItem("user"); // Clear user data
				navigate(""); // Ensure correct redirection path
			}else{
				const storedUser = JSON.parse(localStorage.getItem("user"));
				//console.log("storedUser",storedUser)
				setUserData(storedUser);
			}
		}, [navigate]);


	const [formData, setFormData] = useState({
		n_grievance_id: "",
		n_status: "",
		c_action_taken: "",
		d_close_date: ""
		  });
	  
	const totalScore = [
			formData.n_commitment_and_attendance,
			formData.n_practical_skills_assessments,
			formData.n_vocational_training,
		    formData.n_pre_and_post_training_results,
			formData.n_market_oriented_thinking
			].reduce((sum, val) => sum + Number(val || 0), 0);
	 const [errors, setErrors] = useState({});
     const [grievance, setgrievanceList] = useState([]);	
	 const [selectedUser, setSelectedUser] = useState(null);
	 const [yesno, setYesNoList] = useState([]);
	 const [internes, setRaporteeList] = useState([]);
	 const [columns, setColumns] = useState([]);
	 const [tabledata, settableData] = useState([]);	
	 const [selectedparticipant, setSelectedParticipant] = useState([]);
     const [editMode, setEditMode] = useState(false);
     const [modalData, setModalData] = useState(false);
     const [activeTab, setActiveTab] = useState("default-tab-1"); // Tracks active tab
     const [indiid, setModalId] = useState(null);	
     const [raporteedata, setRapporteeData] = useState({
	  n_stakeholder_id : ""
      });
  useEffect(() => {
	// Switch to "Ajouter un nouvel utilisateur" tab if edit mode is enabled
	if (editMode) {
	  setActiveTab("default-tab-2");
	//setEditMode(false)
	} else {
	  setActiveTab("default-tab-1");
	}
  }, [editMode]);
  
  useEffect(() => {
	 axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_grievance_registration')},{ headers: { 'Content-Type': 'application/json' } }) 
    	.then( (res) => {
	    setgrievanceList(res.data);
	    }).catch( (error) => { console.log(error); }); 
	

	  axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_yes_no_mst')},{ headers: { 'Content-Type': 'application/json' } }) 
	.then( (res) => {
		setYesNoList(res.data);
	  }).catch( (error) => { console.log(error); });

	  axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('v_pmis_grievance_redressal'),cols:strEncode('*') },{ headers: { 'Content-Type': 'application/json' } }) 
				  .then( (res) => {					
					if (!res.data || !res.data || res.data.length === 0) {
						console.warn("Warning: API returned an empty or undefined response.");
						setColumns([]); // Reset columns
						settableData([]); // Reset table data
						return;
					}
					const columnKeys = Object.keys(res.data[0]);
					
					const formattedColumns = columnKeys.map((key) => ({
						name: key.charAt(0).toUpperCase() + key.slice(1),
						selector: row => row[key],
						sortable: true,
						cell: row => row[key] // Show normal column data
					  }));

					  formattedColumns.push({
						name: "Actions",
						cell: (row) => (
							<div>
						  <button className="btn btn-warning btn-sm" onClick={() => handleEdit(row)}>
						  تعديل
						  </button>
						   </div>
						),
					  });
					//console.log("columnKeys",columnKeys)
					setColumns(formattedColumns);
                    settableData(res.data);					
				  }).catch(error => {
					console.error("API Error:", error);
				  });
  }, []);
	
const tabActive = async (user) => {
	setFormData({
	    n_grievance_id: "",
		n_status: "",
		c_action_taken: "",
		d_close_date: ""
	});
  
	 setEditMode(false);
	 setSelectedUser(null);
}

const closeModal = () => {
	setModalData([]);
   }


  const handleEdit = async (user) => {
	//console.log("user.id",user.id)
	setSelectedUser(user);
	try {
	  const response = await axios.post(`${API_BASE_URL}/api/custom/selectall`, {
		t: strEncode('pmis_grievance_redressal'),
		cols : 	strEncode('*'),	
		whrc : strEncode('id = '+user.id+''),
	  }, { headers: { 'Content-Type': 'application/json' } });
  
	 setFormData({
		id : response.data[0].id,
	    n_grievance_id: response.data[0].n_grievance_id,
		n_status: response.data[0].n_status,
		c_action_taken: response.data[0].c_action_taken,
		d_close_date: response.data[0].d_close_date		
	  });

	} catch (error) {
	  console.error("Error fetching user data:", error);
	}
	setEditMode(true);
	setActiveTab("default-tab-2");
  };
  
   // console.log("usertyoe",usertype)
	  const userstatus = [
		{ id: 0, c_name: "يفتح" },
		{ id: 1, c_name: "يغلق" },
	  ];

	  const validateEmail = (email) => {
		const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		return emailRegex.test(email);
	  };
	
	  const validatePassword = (password) => {
		return {
		  length: password.length >= 12,
		  uppercase: /[A-Z]/.test(password),
		  number: /\d/.test(password),
		  specialChar: /[~_!@#^()-+|.,]/.test(password),
		  restrictedChars: !/[&\/\\$%'"`=:;*?<>{}]/.test(password),
		};
	  };
	
	
		const handleChangeDates = (name, date) => {
	  if (!name || !date) return;
	
	  const formattedDate = date ? moment(date).format('YYYY-MM-DD') : '';
	  //const change = { [name]: formattedDate };
	
	 setFormData((prevData) => ({
				...prevData,
				[name]: formattedDate, // Keep existing password if blank
			}));
	  //console.log("Date change:", change);
	};

	 /* const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	
		// Validation Logic
		let newErrors = { ...errors };
	
		if (!value) {
		  newErrors[name] = "This field is required.";
		} else {
		  delete newErrors[name];
		}
	
		if (name === "c_email" && !validateEmail(value)) {
		  newErrors[name] = "Invalid email format.";
		}
	
		if (name === "c_password" ) {
		  const validations = validatePassword(value);
		  if (!validations.length) newErrors[name] = "Password must be at least 12 characters.";
		  if (!validations.uppercase) newErrors[name] = "Password must contain at least one uppercase letter.";
		  if (!validations.number) newErrors[name] = "Password must contain at least one number.";
		  if (!validations.specialChar) newErrors[name] = "Password must contain at least one special character.";
		  if (!validations.restrictedChars) newErrors[name] = "Password contains restricted characters.";
		}
	
		setErrors(newErrors);
	  }; */
	
	  const handlevalidateNumber = (e) => {
  const { name, value } = e.target;
  let numericValue = Number(value);

  // Clamp value between 0 and 10
  if (numericValue < 0) numericValue = 0;
  if (numericValue > 10) numericValue = 10;

  setFormData((prev) => ({
    ...prev,
    [name]: numericValue,
  }));
};

	  const handleChange = (e) => {
		const { name, value } = e.target;
		
		setFormData((prevData) => ({
			...prevData,
			[name]: name === "c_password" && !value ? "" : value, // Keep existing password if blank
		}));
	
		// Validation Logic
		let newErrors = { ...errors };
	
		if (!value) {
			newErrors[name] = "This field is required.";
		} else {
			delete newErrors[name];
		}
	
		if (name === "c_email" && !validateEmail(value)) {
			newErrors[name] = "Invalid email format.";
		}
	
		if (name === "c_password" && value) { // Only validate if password is entered
			const validations = validatePassword(value);
			if (!validations.length) newErrors[name] = "Password must be at least 12 characters.";
			if (!validations.uppercase) newErrors[name] = "Password must contain at least one uppercase letter.";
			if (!validations.number) newErrors[name] = "Password must contain at least one number.";
			if (!validations.specialChar) newErrors[name] = "Password must contain at least one special character.";
			if (!validations.restrictedChars) newErrors[name] = "Password contains restricted characters.";
		}
	
		setErrors(newErrors);
	};

	 
	  const handleChangegrievance = (e) => {
		console.log("we are here")
		const { name, value } = e.target;
		setFormData((prevData) => ({
			...prevData,
			[name]: value, // Keep existing password if blank
		}));

         axios.post(`${API_BASE_URL}/api/custom/selectall`,
			 { t: strEncode('v_pmis_grievance_registration_display'),cols:strEncode('*'),whrc:strEncode('id = "'+e.target.value+'"') },
			 { headers: { 'Content-Type': 'application/json' } }) 
				  .then( (res) => {					
					var data  = res.data
					setSelectedParticipant(data);
					}).catch(error => {
					console.error("API Error:", error);
				  });
	};
	
	  const handleSubmit = async (e) => {
		e.preventDefault();
	   
		let newErrors = {};
		
		if (!editMode) {
		// If there are validation errors, stop submission
		if (Object.keys(newErrors).length > 0) {
		  setErrors(newErrors);
		  return;
		}
	}
		console.log("formdata",formData)
		try {
		  const payload = {
				data: {
					...formData,
					n_user_id: userData?.id,
					n_total_points : totalScore
				}
				};
		  var response;
		  if (!editMode) {
			response = await axios.post(`${API_BASE_URL}/api/grievance/redressal`, payload);
			alert("تم حفظ البيانات بنجاح!");
			setEditMode(false);
			setSelectedUser(null);
			window.location.reload(); // Refresh DataTable
		  } else {
			response = await axios.put(`${API_BASE_URL}/api/grievance/redressalupdate`, { data: formData });
			alert("تم تحديث البيانات بنجاح!");
			setEditMode(false);
			setSelectedUser(null);
			window.location.reload(); // Refresh DataTable
		  }
		   // Reset formData state
		   setFormData({
			n_grievance_id: "",
		n_special_needs: "",
		c_area: "",
		n_commitment_and_attendance: "",
		n_practical_skills_assessments: "",
		n_vocational_training: "",
		n_pre_and_post_training_results: "0",
		n_market_oriented_thinking :'',
		n_total_points :'',
		c_recommendations :''
		  });
	  
		 
		} catch (error) {
		  console.error("Error saving data:", error);
		}
	  };
 

	     const exportData = (type) => {
		 const ws = XLSX.utils.json_to_sheet(tabledata);
		 const wb = XLSX.utils.book_new();
		 XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
	
		 if (type === "csv") {
		  XLSX.writeFile(wb, "data_export.csv");
		} else {
		  XLSX.writeFile(wb, "data_export.xlsx");
		}
	  };
	
	return (
		<div>
			<ol className="breadcrumb float-xl-end">
				<li className="breadcrumb-item"><Link to="/page-option/blank">الصفحة الرئيسية</Link></li>
				<li className="breadcrumb-item"><Link to="/page-option/blank">الإدارة</Link></li>
				<li className="breadcrumb-item active">إدارة المستخدمين</li>
			</ol>
			<h1 className="page-header">الإدارة <small>إنشاء مستخدمين هنا</small></h1>
			<Panel>
				<PanelHeader>إنشاء مستخدمين هنا</PanelHeader>
				<PanelBody>
				<div className="row">
				<div className="col-xl-12">
				<ul className="nav nav-pills">
        <li className="nav-item">
          <a
            href="#default-tab-1"
            data-bs-toggle="tab"
            className={`nav-link ${activeTab === "default-tab-1" ? "active" : ""}`}
            onClick={() => setActiveTab("default-tab-1")}
          >
			 <span className="d-sm-block d-none">قائمة</span>
           
          </a>
        </li>
        <li className="nav-item">
          <a
            href="#default-tab-2"
            data-bs-toggle="tab"
            className={`nav-link ${activeTab === "default-tab-2" ? "active" : ""}`}
            onClick={() => tabActive("default-tab-2")}>
            <span className="d-sm-block d-none">إضافة تقييم المشارك</span>
          </a>
        </li>
      </ul>
					<div className="tab-content panel rounded-0 p-3 m-0">
					<div className={`tab-pane fade ${activeTab === "default-tab-1" ? "active show" : ""}`} id="default-tab-1">
						<button onClick={() => exportData("xlsx")} className="btn btn-success">
								تصدير إلى إكسل
								</button>
							<DataTable
									title="بيانات المستخدم"
									columns={columns}
									data={tabledata}
									pagination
									highlightOnHover
								/>

								
						</div>
						<div className={`tab-pane fade ${activeTab === "default-tab-2" ? "active show" : ""}`} id="default-tab-2">
							<form method="post" onSubmit={handleSubmit}>
									<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">التظلم</label>
									<div className="col-md-9">
										 <Select2 name="n_grievance_id"  value={String(formData.n_grievance_id || '')} 
										  onChange={handleChangegrievance.bind(this)} style={{ width: "100%" }}>
											<option value=''> -- Select -- </option>
											{grievance.map(option => {
											return <option value={String(option.id)} key={option.id} >{option.c_name}</option>
											})}
										 </Select2>								
											{errors.n_grievance_id && <span style={{ color: "red" }}>{errors.n_grievance_id}</span>}
									</div>
								</div>

								<div className="row mb-15px" key="c_action_taken">
								<label className="form-label col-form-label col-md-3">الإجراء الذي يتعين اتخاذه</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="text"
										name= "c_action_taken"
										value={formData.c_action_taken}
										onChange={handleChange}
										/>
                                     {errors.c_action_taken && <span style={{ color: "red" }}>{errors.c_action_taken}</span>}
									</div>
									</div>

								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">حالة</label>
									<div className="col-md-9">
									<select name="n_status" className="form-select" onChange={handleChange} value={formData.n_status}>
										<option value="">يختار</option>
										{userstatus.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_status && <span style={{ color: "red" }}>{errors.n_status}</span>}
									</div>
								</div>

								<div className="row mb-15px" key="c_detailed_grievance">
									<label className="form-label col-form-label col-md-3">تاريخ الإغلاق </label>
									<div className="col-md-9">
									<DatePicker className="form-control mb-5px" type="text" name="d_close_date" dateFormat="yyyy-MM-dd"  selected={formData.d_close_date} onChange={(date) => handleChangeDates('d_close_date', date)}   /><b className="tooltip tooltip-bottom-right">Needed to enter the Date</b> 
										{errors.d_close_date && <span style={{ color: "red" }}>{errors.d_close_date}</span>}
									</div>
								</div>									

                                {!editMode ?
								<button type="submit"  className="btn btn-success w-100px">يحفظ</button>
								:
								<button type="submit" className="btn btn-success w-100px">تحديث</button> }
								</form>
						</div>
						
					</div>
					</div>
					
					</div>
				</PanelBody>
			</Panel>
		
		</div>
	)
}

export default Redressal;